import { Header } from "../../components/Header"
import { useParams } from "react-router-dom";
import { Certificate } from "../../components/Certificate";
import { CertificateData, getCertificate } from "../../remote/scan_data";
import { useEffect, useState } from "react";
import { ScanChildren } from "../../components/ScanChildren";
import { Box, CircularProgress, Container } from "@mui/material";

export const TreeCertificate = () => {
	const params = useParams()
	const entityId = params.entityId;

	if ( ! entityId) {
		return <CircularProgress />
	}

	const [certificateData, setCertificateData] = useState<CertificateData | null>(null);
	useEffect(() => {
		getCertificate(entityId, (data, resp) => {
			if (data) {
				setCertificateData(data);
			} else {
				setCertificateData(null);
			}
		});
	}, [setCertificateData]);

	return (certificateData ? <>
		<Header />
		<Container>
			<Certificate id={entityId} data={certificateData} hideChildren/>
			<Box margin={1}></Box>
			<ScanChildren data={certificateData.children} />
		</Container>
	</> : <CircularProgress />)
}
